<script lang="ts" setup>import { toRef as _toRef } from 'vue';

import { useSharedData } from '@consumer/composables/sharedData'
import { useFavoritesStore } from '@consumer/services/favorites/store'
import FavoritesMenuDesktop from './FavoritesMenuDesktop.vue'
import FavoritesMenuMobile from './FavoritesMenuMobile.vue'

const __$temp_1 = (useSharedData()),
  currentUser = _toRef(__$temp_1, 'currentUser');
const favorites = useFavoritesStore()

if (!import.meta.env.SSR && currentUser.value) {
  // It could be that at this point the `DOMContentLoaded` event has already fired (e.g vue pages), so
  // the DOMContentLoaded event listener below would not be triggered.
  if (document.readyState !== 'loading') {
    setTimeout(favorites.syncGuestFavorites, 500)
  }
  else {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(favorites.syncGuestFavorites, 500)
    })
  }
}
</script>

<template>
  <div class="flex items-center h-full">
    <FavoritesMenuDesktop class="hidden lg:flex"/>
    <FavoritesMenuMobile class="lg:hidden"/>
  </div>
</template>
